export default __webpack_public_path__ + "static/media/cloud1.af8dd3c0.png";